<template>
  <div class="container mb-5">
    <div class="row mb-5 my-md-5">
      <div class="col-sm-6 offset-sm-3">
        <h1 class="text-center">
          {{ $t("exPagantes") }}
        </h1>
      </div>
    </div>
    <ExPagantesTable />
  </div>
</template>

<script>
import ExPagantesTable from './components/ExPagantesTable.vue';

export default {
  components: { ExPagantesTable },
};
</script>
